import React from "react";

//MUI
import Chip from '@mui/material/Chip';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Box } from "@mui/material";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top'
        }
    }
};

const SemesterChart = ({ label, data }) => {
    return (
        <>
            <Bar options={options} data={data} />
            <Box sx={{textAlign: 'center', mt: 2.5}}>
                <Chip
                    label={label}
                    size="small"
                    color='primary'
                    sx={{ borderRadius: '6px', p: 1, fontWeight: 'bold' }}
                />
            </Box>
        </>
    );
};

export default SemesterChart;